import styled from "styled-components";
import { layout, color, typography, space, border } from "styled-system";
import { remCalc, media } from "../../../theme/style-utils-coras-nua";
import defaultTheme from "../../../theme/theme-test-override";

const BaseInputStyles = styled.input`
    ${space}
    ${border}
    ${layout}
    ${color}
    ${typography}
    width: ${props => (props.fieldWidth ? props.fieldWidth : "100%")};
    ${media.md.up`
        .small & {
            width: 25%;
        }
        .medium & {
            width: 48%;
        }
        .prefix & {
            width: 100%;
        }
        .small .years-months-field &, .medium .years-months-field &{
            width: 100%
        }
    `}

    ${media.sm.down`
        .small &, .medium & {
            width: 100%;
        }
        width: 100%;
    `}
    box-sizing: border-box;
    -webkit-transition: border 500ms ease-out;
    -moz-transition: border 500ms ease-out;
    -o-transition: border 500ms ease-out;
    transition: border 500ms ease-out;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    transition: all ease-in-out 0.3s;
    &::placeholder {
        color: ${props => props.theme.colors.monotoneMidDark};
    }
    &:focus {
        outline: none;
        border-color: ${props => props.theme.colors.primary};
    }
    &[readonly] {
        border-color: ${props => props.theme.colors.backgroundLight};
        cursor: not-allowed;
        &:focus {
            border-color: ${props => props.theme.colors.monotoneMidLight};
        }
    }
    .readonly-alt-style &[readonly] {
        border-color: ${props => props.theme.colors.monotoneMidLight};
        background: ${props => props.theme.colors.monotoneMidLight};
        cursor: not-allowed;
        &:focus {
            border-color: ${props => props.theme.colors.monotoneMidLight};
        }
    }
    &[disabled] {
        border-color: ${props => props.theme.colors.monotoneMid};
        background: rgba(${props => props.theme.colors.backgroundLight}, 0.3);
        color: ${props => props.theme.colors.monotoneMidDark};
        cursor: not-allowed;
        &:focus {
            border-color: ${props => props.theme.colors.monotoneMid};
        }
    }
    .u-px-input-1 &{
        padding-left: ${props => props.theme.space[1]};
        padding-right: ${props => props.theme.space[1]};
    }
    .u-text-input-centre &{
        text-align: center !important;
        &[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button{
            -webkit-appearance: none;/*For Webkit*/
        }
        &[type=number]{
            -moz-appearance: textfield;/*For FireFox*/
        }
    }
    .u-text-input-right &{
        text-align: right !important;
        &[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button{
            -webkit-appearance: none;/*For Webkit*/
        }
        &[type=number]{
            -moz-appearance: textfield;/*For FireFox*/
        }
    }
    .u-width-input-60px &{
            width: ${remCalc(60)};
            max-width: ${remCalc(60)};
            min-width: ${remCalc(60)};
    }
    .u-width-input-120px &{
            width: ${remCalc(120)};
            max-width: ${remCalc(120)};
            min-width: ${remCalc(120)};
    }
    ${media.sm.down`
        .u-width-input-sm-60px &{
            width: ${remCalc(60)};
            max-width: ${remCalc(60)};
            min-width: ${remCalc(60)};
        }
        .u-width-input-sm-120px &{
            width: ${remCalc(120)};
            max-width: ${remCalc(120)};
            min-width: ${remCalc(120)};
        }
    `}
    ${media.xs.down`
        .u-width-input-xs-60px &{
            width: ${remCalc(60)};
            max-width: ${remCalc(60)};
            min-width: ${remCalc(60)};
        }
        .u-width-input-xs-120px &{
            width: ${remCalc(120)};
            max-width: ${remCalc(120)};
            min-width: ${remCalc(120)};
        }
    `}
`;
BaseInputStyles.defaultProps = {
    theme: {
        ...defaultTheme
    },
    px: 4,
    py: 0,
    borderWidth: "0.0625rem",
    borderRadius: 0,
    borderStyle: "solid",
    borderColor: "monotoneMid",
    height: "3rem",
    color: "monotoneDark",
    backgroundColor: "brilliant",
    fontFamily: "fontFamily",
    fontSize: 2
};

const StyledInput = styled(BaseInputStyles)`
    &[type="date"] {
        background-image: url("data:image/svg+xml;base64,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");
        background-repeat: no-repeat;
        background-position: center right ${remCalc(20)};
        &::-webkit-inner-spin-button {
            display: none;
        }
        &::-webkit-calendar-picker-indicator {
            opacity: 0;
            width: ${remCalc(30)};
            height: ${remCalc(30)};
        }
    }
    &[type="file"] {
        width: ${remCalc(0.1)};
        height: ${remCalc(0.1)};
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
`;
StyledInput.defaultProps = {
    tag: "input"
};
export default StyledInput;
export { BaseInputStyles };
